var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full overflow-x-auto"},[_c('BaseMap',_vm._l((_vm.stations),function(station){return _c('MapCard',{key:station.id,attrs:{"details":station.details,"y":station.y,"x":station.x,"img":station.img,"station":{ ...station },"setDetails":_vm.setDetails}})}),1),_c('StationDetailsSlider',{attrs:{"closeSlider":_vm.closeSlider,"sliderOpen":_vm.sliderOpen,"station":{
      ..._vm.selectedStation.details,
      img: _vm.selectedStation.img,
      id: _vm.selectedStation.id,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }